export default "__VITE_ASSET__89fe9dcf__"